import { render } from "./IndividualData.vue?vue&type=template&id=28e4db4c"
import script from "./IndividualData.vue?vue&type=script&lang=js"
export * from "./IndividualData.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/tmulag_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__